import React, {useEffect, useMemo, useRef, useState} from "react";
import {
  Box,
  Drawer,
  IconButton,
  List, ListItem,
  ListItemButton, ListItemIcon, ListItemText,
  Stack, Toolbar,
  Typography
} from "@mui/material";
import {Link, NavLink, useParams} from "react-router-dom";
import {
  Call, CallEnd, CallMissed,
  ChevronLeft,
  ChevronRight,
  MenuOpen, OpenInNew, PhoneCallback,
  PlayArrow
} from "@mui/icons-material";
import axios from "../../axios/axios";
import {teal} from "@mui/material/colors";
import moment from "moment";

const drawerWidth = 300

export const MainLayout = ({children, primary, secondary}) => {
  const {flowUid} = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [chats, setChats] = useState([]);
  const [page, setPage] = useState(0)

  const headerRef = useRef();

  useEffect(() => {
    const flow = flowUid || localStorage.getItem("flow_uid") || null;
    const params = {
      page: page || 0,
      size: 15,
      type: "CHAT_BOT"
    };
    if (flow) {
      params.flow = flow;
    }

    axios.get(`/api/conversation`, {params: {...(params || {})}})
      .then(response => {
        setChats(prev => [...(prev || []), ...response?.data?.content])
      })
      .catch((error) => console.log(error?.message))
  }, [page, flowUid])

  const height = useMemo(() => {
    let val = 0;
    if (headerRef.current) {
      val = headerRef.current.offsetHeight || 0;
    }
    return val;
  }, [headerRef.current])

  const sidebarContent = useMemo(() => {
    const flow = flowUid || localStorage?.getItem("flow_uid") || null;
    return (
      <Box sx={{p: 1, width: '100%', overflowY: "auto"}}>
        <List>
          <ListItemButton
            component={Link}
            to={flow ? `/flow/${flow}` : "/"}
            sx={{
              color: "white",
              borderRadius: 3,
              mb: 1,
              textWrap: "nowrap",
              py: 0.5,
              background: "rgba(132, 145, 247, 0.8)",
              "&:hover": {
                background: "rgba(132, 145, 247, 1)"
              }
            }}
          >
            <ListItemIcon sx={{minWidth: 28}}><PlayArrow style={{color: "#FFF", fontSize: 18}}/></ListItemIcon>
            <ListItemText primary={"Start new conversation"} primaryTypographyProps={{fontSize: 15}}/>
          </ListItemButton>
          <ListItem>
            <ListItemText primary={"History"} primaryTypographyProps={{fontWeight: 700}}/>
          </ListItem>
          {
            chats?.map(item => (
              <ListItemButton
                key={item?.id}
                sx={{"&.active": {bgcolor: `${teal[50]} !important`}, borderRadius: 3, py: 0, mb: 0.5}}
                component={NavLink} to={flow ? `/flow/${flow}/chat/${item?.id}` : `/chat/${item?.id}`}
              >
                {/*<ListItemIcon sx={{minWidth: 32}}>*/}
                {/*  {*/}
                {/*    {*/}
                {/*      "ACTIVE": <Call color={"green"} />,*/}
                {/*      "FAILED": <PhoneCallback color={"red"} />,*/}
                {/*      "FINISHED": <CallEnd color={"orange"} />,*/}
                {/*      [undefined]: <CallMissed color={"red"} />*/}
                {/*    }[item?.status]*/}
                {/*  }*/}
                {/*</ListItemIcon>*/}
                <ListItemText
                  primary={`${item.id}. ${moment(item?.dateCreated)?.format("DD MMM YYYY HH:mm")}`}
                  secondary={item?.flowName}
                  primaryTypographyProps={{fontSize: 14}}
                  secondaryTypographyProps={{variant: "body2", fontSize: 12}}
                />
              </ListItemButton>
            ))
          }
          <ListItemButton onClick={() => setPage(prev => prev + 1)}>
            Load More
          </ListItemButton>
        </List>
      </Box>
    )
  }, [chats, flowUid])

  return <>
    <Toolbar id={"header"} ref={headerRef} sx={{bgcolor: "#FFF"}}>
      <Stack direction={"row"}
             sx={{width: "100%", pt: 1}} gap={1}
             justifyContent={"space-between"}
             alignItems={"center"}>
        <Stack direction={"column"} alignItems={"center"} justifyContent={"center"} gap={1}>
          <Stack direction={"row"}
                 sx={{width: "100%"}}
                 justifyContent={isOpen ? "space-between" : "center"}
                 alignItems={"center"}>
            <img src={'/logo.svg'} alt={"Logo"} width={40} height={"auto"}/>
          </Stack>
          {/*<UserInfo />*/}
        </Stack>

        <Box sx={{display: {xs: 'none', sm: "flex"}}}>
          {primary}
        </Box>

        <Stack direction={"row"} gap={2} alignItems={"center"}>
          {secondary}
          {window.location !== window.parent.location && <IconButton
            component={"a"}
            href={`${window.location}?json_url=${localStorage.getItem("json_url")}`}
            target={"_blank"}
          >
            <OpenInNew fintSize={"small"}/>
          </IconButton>}
        </Stack>
      </Stack>
    </Toolbar>
    <Stack direction="row" sx={{height: `calc(100% - ${height}px)`, width: '100vw'}}>
      <Drawer
        open={isOpen}
        onClose={() => setIsOpen(false)}
        variant={"temporary"}
        sx={{
          width: `${drawerWidth}px !important`,
          border: 0,
          height: "100%",
          overflowY: "auto",
          boxShadow: 0,
          py: 1,
          px: 2,
          zIndex: 100000,
          display: {xs: "flex", md: "none"},
          '& .MuiDrawer-paper': {
            border: 0,
            boxShadow: 0,
            zIndex: 100000,
            width: `${drawerWidth}px !important`,
          },
        }}
      >
        <Toolbar>
          <Stack direction={"row"}
                 sx={{width: "100%"}}
                 justifyContent={isOpen ? "space-between" : "center"}
                 alignItems={"center"}>
            <img src={"/logo.svg"} alt={"Logo"} width={40} height={"auto"}/>
            <Box sx={{px: 1, display: {xs: 'none', sm: "block"}}}>
              <Typography fontSize={15}>OpenBrain</Typography>
              <Typography fontSize={8} textTransform={"uppercase"} fontWeight={"bold"}>voice bot</Typography>
            </Box>

            <IconButton onClick={() => setIsOpen(!isOpen)}>
              <MenuOpen/>
            </IconButton>
          </Stack>
        </Toolbar>
        {sidebarContent}
      </Drawer>
      {isOpen && <Box
        sx={{
          flex: 1,
          display: {xs: "none", md: "flex"},
          minWidth: '260px'
        }}
      >
        {sidebarContent}
      </Box>}
      <Box sx={{
        maxHeight: `calc(100vh - ${height}px)`,
        height: "100%",
        minWidth: '300px',
        flex: 4,
        position: "relative",
        overflowY: "auto"
      }}>

        <IconButton
          size={"small"}
          sx={{
            position: "absolute",
            top: "50%",
            left: 10,
            zIndex: 1000,
            transform: 'translate(0%, -50%)',
            p: 0.5
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <ChevronLeft size={15}/> : <ChevronRight size={15}/>}
        </IconButton>
        {children}
      </Box>
    </Stack>
  </>
}
